import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Collapse, Badge } from 'reactstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../store/actions/actions';

import SidebarRun from './Sidebar.run';

import config from '../../helper/Config';

import ls from 'localstorage-slim';
const STORAGE_KEY = `/${config.BASE_PATH}`;


/** Component to display headings on sidebar */
const SidebarItemHeader = ({item}) => (
    <li className="nav-heading">
        <span><Trans i18nKey={item.translate}>{item.heading}</Trans></span>
    </li>
)

/** Build a sub menu with items inside and attach collapse behavior */
const SidebarSubItem = ({item, isActive, handler, children, isOpen}) => (
    <li className={ isActive ? 'active' : '' }>
        <div className="nav-item" onClick={ handler } style={{whiteSpace:'normal'}}>
            {item.label && <Badge tag="div" className="float-right" color={item.label.color}>{item.label.value}</Badge>}
            {item.icon && <em className={item.icon}></em>}
            <span>{item.name}</span>
        </div>
        <Collapse isOpen={ isOpen }>
            <ul id={item.path} className="sidebar-nav sidebar-subnav">
                { children }
            </ul>
        </Collapse>
    </li>
)

/** Component used to display a header on menu when using collapsed/hover mode */
const SidebarSubHeader = ({item}) => (
    <li className="sidebar-subnav-header">{item.name}</li>
)

class Sidebar extends Component {
    state = {
        collapse: {},
        menu: []
    }

    async componentDidMount() {
        clearInterval(config.TIME_INTERVAL);
        await this.fetchAppMenu();
        
        // pass navigator to access router api
        SidebarRun(this.navigator, this.closeSidebar);
        // prepare the flags to handle menu collapsed states
        this.buildCollapseList()

        // Listen for routes changes in order to hide the sidebar on mobile
        this.props.history.listen(this.closeSidebar);
    }

    // get menu base on privilege 
    fetchAppMenu = async() => {
        try {
            const rawState = ls.get(STORAGE_KEY, { decrypt: true });

            if (rawState === null) return ;
            const state = JSON.parse(rawState);

            let menuList = state.menu.listMenu;
            if(!menuList) menuList=[];
            this.setState({
                menu: menuList
            })
        } catch (error) {
            console.log(error)
            localStorage.removeItem(`/${config.BASE_PATH}`)
            localStorage.removeItem(`/${config.BASE_PATH}_token`)
            window.location.pathname = `${config.BASE_URL}/login`;
        }
    }

    closeSidebar = () => {
        this.props.actions.changeSetting('asideToggled', false);
    }

    assignCurrentPrivilege = (item) => {
        this.props.actions.assignCurrentPrivilege(item);
        // document.querySelectorAll('.sidebar-subnav.nav-floating').forEach(element => element.remove());
        // document.querySelectorAll('.sidebar-backdrop').forEach(element => element.remove());
        // document.querySelectorAll('.sidebar li.open').forEach(element => element.classList.remove('open'));

    }

    SidebarItem = (item, isActive, action) => {
        return (<li className={ isActive ? 'active' : '' }>
            <Link to={item.path} title={item.name} style={{whiteSpace:'normal'}} onClick={() => this.assignCurrentPrivilege(item)}>
                {item.label && <Badge tag="div" className="float-right" color={item.label.color}>{item.label.value}</Badge>}
                {item.icon && <em className={item.icon}></em>}
                <span>{item.name}</span>
            </Link>
        </li>)
    }

    /** prepare initial state of collapse menus. Doesnt allow same route names */
    buildCollapseList = () => {
        let collapse = {};
        this.state.menu
            .filter(({heading}) => !heading)
            .forEach(({id, name, path, submenu}) => {
                collapse[id] = this.routeActive(submenu ? submenu.map(({path})=>path) : path)
            })
        this.setState({collapse});
    }

    navigator = route => {
        clearInterval(config.TIME_INTERVAL);
        if(route.includes(config.BASE_URL) && config.BASE_URL != ""){
            let path = route.split(config.BASE_URL);
            route = path[1];
        }
        this.props.history.push(route.replace('#','')); // remove '#' in case of use HashRouter
    }

    routeActive(paths, subItem) {
        paths = Array.isArray(paths) ? paths : [paths];
        let pathMatch = paths.some(p => 
            (this.props.location.pathname.indexOf(p) > -1) || 
            ((this.props.location.pathname+''+this.props.location.search).indexOf(p) > -1))
        
        if(subItem){
            if(pathMatch){
                this.assignCurrentPrivilege(subItem);
            }
        }
        return pathMatch
    }

    toggleItemCollapse(stateName) {
        // eslint-disable-next-line
        for (let c in this.state.collapse) {
            if (this.state.collapse[c] === true && c !== stateName)
                this.setState({
                    collapse: {
                        [c]: false
                    }
                });
        }
        this.setState({
            collapse: {
                [stateName]: !this.state.collapse[stateName]
            }
        });
    }

    getSubRoutes = item => item.submenu.map(({path}) => path)

    /** map menu config to string to determine which element to render */
    itemType = item => {
        if (item.heading) return 'heading';
        if (!item.submenu) return 'menu';
        if (item.submenu) return 'submenu';
    }

    render() {
        return (
            <aside className='aside-container'>
                { /* START Sidebar (left) */ }
                <div className="aside-inner">
                    <nav data-sidebar-anyclick-close="" className="sidebar" style={{paddingBottom:'220px'}}>
                        { /* START sidebar nav */ }
                        <ul className="sidebar-nav">
                            { /* END user info */ }

                            { /* Iterates over all sidebar items */ }
                            {
                                this.state.menu.map((item, i) => {
                                    // heading
                                    if(this.itemType(item) === 'heading')
                                        return (
                                            <SidebarItemHeader item={item} key={i} />
                                        )
                                    else {
                                        if(this.itemType(item) === 'menu')
                                            return (
                                                this.SidebarItem(subitem, this.routeActive(subitem.path, subitem))
                                            )
                                        if(this.itemType(item) === 'submenu')
                                            return [
                                                <SidebarSubItem item={item} isOpen={this.state.collapse[item.id]} handler={ this.toggleItemCollapse.bind(this, item.id) } isActive={this.routeActive(this.getSubRoutes(item))} key={i}>
                                                    <SidebarSubHeader item={item} key={i}/>
                                                    {
                                                        item.submenu.map((subitem, i) =>
                                                            this.SidebarItem(subitem, this.routeActive(subitem.path, subitem))
                                                        )
                                                    }
                                                </SidebarSubItem>
                                            ]
                                    }
                                    return null; // unrecognized item
                                })
                            }
                        </ul>
                        { /* END sidebar nav */ }
                    </nav>
                </div>
                { /* END Sidebar (left) */ }
            </aside>
        );
    }
}

Sidebar.propTypes = {
    actions: PropTypes.object,
    settings: PropTypes.object
};

const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translations')(withRouter(Sidebar)));
